// Wire-shape responses for /comments + /admin/comments + /admin/comments/
// blocklist.
import { z } from 'zod';
import { Comment, CommentModerationSettings, CommentReport, ContentBlocklistEntry, } from './comment.js';
export const CommentResponse = z.object({ comment: Comment });
export const CommentReactionCapabilities = z.object({
    reactionsEnabled: z.boolean(),
    dislikesEnabled: z.boolean(),
    attachmentsEnabled: z.boolean(),
    guestCommentsEnabled: z.boolean(),
    domEditorReadonlyPreviewEnabled: z.boolean(),
    domEditorComposerEnabled: z.boolean(),
});
export const CommentListResponse = z.object({
    comments: z.array(Comment),
    total: z.number().int().nonnegative(),
    limit: z.number().int().positive(),
    offset: z.number().int().nonnegative(),
    capabilities: CommentReactionCapabilities,
});
export const SubscriptionStatusResponse = z.object({
    subscribed: z.boolean(),
});
export const ModerationSettingsResponse = z.object({
    settings: CommentModerationSettings,
});
export const CommentReportListResponse = z.object({
    reports: z.array(CommentReport),
    total: z.number().int().nonnegative(),
    limit: z.number().int().positive(),
    offset: z.number().int().nonnegative(),
});
export const BulkActionResponse = z.object({
    /** How many IDs the action successfully applied to. May be < ids.length
     *  when some ids referred to already-archived rows or to rows whose
     *  current status couldn't legally transition into the requested
     *  one. */
    affected: z.number().int().nonnegative(),
    /** IDs that were skipped + a short reason for each. The route layer
     *  surfaces this so an admin sees per-row outcomes without a re-fetch
     *  of every id. */
    skipped: z.array(z.object({
        id: z.string().uuid(),
        reason: z.string(),
    })),
});
export const BlocklistEntryResponse = z.object({
    entry: ContentBlocklistEntry,
});
export const BlocklistListResponse = z.object({
    entries: z.array(ContentBlocklistEntry),
});
export const OkResponse = z.object({ ok: z.literal(true) });
//# sourceMappingURL=responses.js.map